import { DataContext } from "./../../context/DataContext";
import { getLocaleUrl } from "../../utils/getLocaleUrl";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React from "react";

const baseUrl = process.env.REACT_APP_WP_BASE_URL || `https://osuonomio.com`;

export const Link = ({ children, to, ...props }) => {
	const { i18n } = useTranslation();
	const { languages } = React.useContext(DataContext);

	if (!languages) {
		return (
			<RouterLink to={to} {...props}>
				{children}
			</RouterLink>
		);
	}

	to = `${to?.startsWith(baseUrl) ? to.replace(baseUrl, "") : to}`;
	to = getLocaleUrl(to, i18n["language"], languages["available"]);

	return (
		<RouterLink {...props} to={to}>
			{children}
		</RouterLink>
	);
};
